// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"94121ad4","498":"ef248b37","703":"f24a5849"}[chunkId] + ".chunk.js";
};